import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99992 11.1666L5.91659 15.25C5.76381 15.4028 5.56936 15.4791 5.33325 15.4791C5.09714 15.4791 4.9027 15.4028 4.74992 15.25C4.59714 15.0972 4.52075 14.9028 4.52075 14.6666C4.52075 14.4305 4.59714 14.2361 4.74992 14.0833L8.83325 9.99998L4.74992 5.91665C4.59714 5.76387 4.52075 5.56942 4.52075 5.33331C4.52075 5.0972 4.59714 4.90276 4.74992 4.74998C4.9027 4.5972 5.09714 4.52081 5.33325 4.52081C5.56936 4.52081 5.76381 4.5972 5.91659 4.74998L9.99992 8.83331L14.0833 4.74998C14.236 4.5972 14.4305 4.52081 14.6666 4.52081C14.9027 4.52081 15.0971 4.5972 15.2499 4.74998C15.4027 4.90276 15.4791 5.0972 15.4791 5.33331C15.4791 5.56942 15.4027 5.76387 15.2499 5.91665L11.1666 9.99998L15.2499 14.0833C15.4027 14.2361 15.4791 14.4305 15.4791 14.6666C15.4791 14.9028 15.4027 15.0972 15.2499 15.25C15.0971 15.4028 14.9027 15.4791 14.6666 15.4791C14.4305 15.4791 14.236 15.4028 14.0833 15.25L9.99992 11.1666Z",
		fill: "currentColor"
	})
});
export default SvgIconClose;
